interface LogoProps {
  variant?: "dark" | "light"
  className?: string
  size?: number | string
  title?: string
}

const AMBER = "#D58D30"
const DARK = "#151E20"
const LIGHT = "#FFFFFF"

export function Logo({ variant = "dark", className, size, title = "BierTrack" }: LogoProps) {
  const main = variant === "dark" ? DARK : LIGHT
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 288 288"
      role="img"
      aria-label={title}
      className={className}
      width={size}
      height={size}
      style={{ fillRule: "evenodd", clipRule: "evenodd", strokeLinejoin: "round", strokeMiterlimit: 2 }}
    >
      <title>{title}</title>
      <path
        fill={main}
        d="M264.955,166.514C263.348,181.462 261.266,199.837 241.929,224.851C203.844,274.117 126.621,276.946 96.939,236.177C80.292,213.31 93.198,193.511 118.388,201.852C121.948,203.031 168.13,227.178 206.003,189.027C224.505,170.39 226.98,143.789 227.38,139.491C228.262,130.006 229.64,121.399 241.458,119.254C249.355,117.821 267.42,123.917 264.955,166.514Z"
      />
      <path
        fill={AMBER}
        d="M98.578,258.27C77.642,249.964 41.074,231.731 26.92,179.389C8.594,111.621 67.528,61.986 83.176,83.749C92.993,97.403 76.388,116.314 75.995,116.873C40.212,167.797 61.176,230.869 103.847,258.196C113.361,264.289 98.968,258.429 98.578,258.27Z"
      />
      <path
        fill={main}
        d="M201.316,72.68C191.002,62.892 165.558,36.199 111.548,44.78C87.787,48.555 64.213,62.083 50.417,73.367C39.165,82.568 69.882,28.103 124.569,19.847C188.46,10.202 222.673,53.59 225.587,54.152C228.476,54.709 239.645,34.037 241.02,51.523C244.203,91.979 243.47,92.454 241.32,94.278C237.234,97.746 197.014,91.145 196.848,91.018C191.529,86.955 202.574,79.048 203.31,78.318C205.524,76.121 201.856,73.306 201.316,72.68Z"
      />
    </svg>
  )
}
